// Returns a boolean indicating whether the given string matches any of the values in the
// given array (with substring matching). The substring checks are case-insensitive.
// eslint-disable-next-line import/prefer-default-export
export var stringMatchesArrayIgnoreCase = function (arr, str) {
    return arr.some(function (element) {
        if (str.toLowerCase().includes(element.toLowerCase())) {
            return true;
        }
        return false;
    });
};
